export { default } from 'cccisd-game-avatarbuilder';
